import Position from "../types/PositionType";
import { Canvas } from "./Canvas";
import { Projectile } from "./Projectile";
import { Enemy } from "./Enemy";
import { Sprite } from "./Sprite";
import archeryTower from "../static/ArcherTower/TowerBasisNew.png";
import archeryTower66p from "../static/ArcherTower/TowerBasisNew66p.png";
import archeryProjectile from "../static/ArcherTower/TowerProjectile.png";
import mageTower from "../static/MageTower/TowerBasisNew.png";
import mageTower66p from "../static/MageTower/TowerBasisNew66p.png";
import mageProjectile from "../static/MageTower/TowerProjectile.png";

export class Tower extends Sprite {
  private _towerRange: number;
  private _firePerFrameCount: number;
  private _target: Enemy | null = null;
  private _projectiles: Projectile[] = [];
  private _isArcherTower: boolean;

  constructor(
    position: Position,
    canvas: Canvas,
    isArcherTower: boolean = true,
    canvasScale: number = 1
  ) {
    super(
      position,
      getProperTowerSprite(isArcherTower, canvasScale),
      canvas,
      {
        maxX: 3,
        maxY: 1,
      },
      64,
      64
    );
    this._towerRange = isArcherTower ? 175 : 125;
    this._firePerFrameCount = 0;
    this._isArcherTower = isArcherTower;
  }

  public draw() {
    super.draw(true);

    this.canvas.drawCircle(
      this.center.x,
      this.center.y,
      this._towerRange,
      "rgba(0, 0, 0, 0.05)"
    );
    this._firePerFrameCount++;
  }

  public update() {
    this.draw();

    if (this._firePerFrameCount % 50 === 0 && this._target) {
      this._projectiles.push(
        new Projectile(
          { x: this.center.x, y: this.center.y - 22 },
          5,
          this._target,
          this.canvas,
          this.isArcherTower ? archeryProjectile : mageProjectile,
          this.isArcherTower ? 3 : 1,
          1
        )
      );
    }
  }

  public get position(): Position {
    return this.position;
  }

  public set position(position: Position) {
    this.position = position;
  }

  public get towerRange(): number {
    return this._towerRange;
  }

  public set towerRange(towerRange: number) {
    this._towerRange = towerRange;
  }

  public get projectiles(): Projectile[] {
    return this._projectiles;
  }

  public set projectiles(projectiles: Projectile[]) {
    this._projectiles = projectiles;
  }

  public get target(): Enemy | null {
    return this._target;
  }

  public set target(enemy: Enemy | null) {
    this._target = enemy;
  }

  public get isArcherTower(): boolean {
    return this._isArcherTower;
  }

  public set isArcherTower(isArcherTower: boolean) {
    this._isArcherTower = isArcherTower;
  }
}

const getProperTowerSprite = (
  isArcherTower: boolean,
  canvasScale: number
): string => {
  return isArcherTower
    ? canvasScale === 1
      ? archeryTower
      : archeryTower66p
    : canvasScale === 1
    ? mageTower
    : mageTower66p;
};
